import { ErrorView } from "@/components/ui/layout/error/errorView"
import { BoxShopItemForm, type BoxShopItemFormRef } from "@/modules/boxShop/components/boxShopItemForm"
import type { BoxShopItemEntity } from "@/modules/boxShop/entities/boxShopItemEntity"
import { useSidebar } from "@/modules/sidebar/hooks/useSidebar"
import type { SidebarNavigatorParams } from "@/modules/sidebar/sidebarTypes"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { Suspense, type Ref } from "react"
import { ErrorBoundary } from "react-error-boundary"

export const useBoxShopSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToBoxShopItemForm = async ({
    boxShopItemFormRef,
    args,
    item,
  }: {
    boxShopItemFormRef: Ref<BoxShopItemFormRef>
    args: SidebarNavigatorParams
    item?: BoxShopItemEntity
  }) => {
    await sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxShopItemForm item={item} ref={boxShopItemFormRef} />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => {
        if (boxShopItemFormRef && "current" in boxShopItemFormRef && boxShopItemFormRef.current) {
          return boxShopItemFormRef.current.onClose()
        }
        return Promise.resolve(true)
      },
      ...args,
    })
  }

  return {
    navigateToBoxShopItemForm,
  }
}
